import { Link, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import PortalAlert from '../../common/PortalAlert';

class BannerMaintenance extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col className="p-0">
            <PortalAlert
              severity="info"
              icon="/img/logos/banner.svg"
              alt="banner"
              title="Banner Maintenance"
              isBodyUnderTitle={true}
            >
              <Typography component="p" variant="smaller" id="dashboard__test-portal-alert">
                Banner, LeoOnline, Registration, Touchnet, and related websites will be unavailable
                due to fiscal year-end processing starting this Tuesday. Maintenance will begin June
                30 at 12:00 PM and service is expected to be restored by July 1 at 10:00 AM (22
                hours later). Some functionality of MyODU Portal will not work during this
                maintenance window, including myCourses, Up Next, and Course Collaboration Tool
                (CCT).
                {/*See <Link*/}
                {/*    href={"https://www.odu.edu/information-technology-services/article/banner-migration-to-cloud"}>*/}
                {/*    Banner Migration to Ellucian Managed Cloud*/}
                {/*</Link> for details.*/}
              </Typography>
            </PortalAlert>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default BannerMaintenance;
